__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-07-30-1785423169-stable-dev/";